module.exports = __webpack_public_path__ + "static/media/testCustomerOrder_logo.db67e5ec.png";